export { Notifier } from './notifier';
export { BaseNotifier } from './base_notifier';
export { QueryInfo } from './queries';
export { Scope } from './scope';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@airbrake/browser/esm/index.js
// module id = 3783
// module chunks = 31